// src/index.js
import ChatBot from './ChatBot.jsx';
import './ChatBot.css';

// Export the component as both named and default export
export { ChatBot };
export default ChatBot;
